import React from 'react'
import './About.css'
import { assets } from '../../assets/assests'

export const About = () => {
  return (
    <section className="about-section" id='About' >
      <div className="about-container">
        <h2 className="section-title"  data-aos="fade-up" data-aos-duration="600">About <span className="highlight">Me</span></h2>
        <div className="about-content" data-aos="fade-up">
          <img src={assets.ragul3_icon} alt="Profile" className="about-photo" data-aos="zoom-in" />
          <div className="about-text" data-aos="fade-left">
            <p>
            Hello! I'm <strong>Ragul</strong>, a self-taught React developer with a strong foundation in <span className="highlight-box">HTML</span>, <span className="highlight-box">CSS</span>, <span className="highlight-box">JavaScript</span>, and <span className="highlight-box">React.js</span>. I specialize in building responsive, user-friendly web interfaces using modern tools and clean code.
          </p>

          <p>
            I've learned by doing — building real applications, solving real problems, and constantly improving my skills through hands-on experience.
          </p>

          <p>
            I focus on writing modular components, managing state with React hooks, and creating smooth, dynamic user experiences. I'm always curious, committed, and ready to contribute to meaningful projects.
          </p>


          </div>
        </div>
      </div>
    </section>
  )
}
